import { Component, OnInit, ViewChild } from '@angular/core';

import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Acesso } from 'src/app/core/acesso';
import { Aluno } from 'src/app/core/aluno';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { CpfPipe } from 'src/app/pipes/cpf.pipe';
import { AlunoService } from 'src/app/services/aluno/aluno.service';
import { FuncoesUteisService } from 'src/app/services/commons/funcoes-uteis.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { BaseComponent } from '../../architeture/base/base.component';
import { FiltroAluno } from '../../core/filtro/filtro-aluno';
import { PageInfo } from '../../core/page-info';
import { DataUtilService } from '../../services/commons/data-util.service';
import { ConfirmDialogComponent } from '../common/confirm-dialog/confirm-dialog.component';
import { MatriculaSecretaria } from 'src/app/core/matricula-secretaria';
import { MatriculaSecretariaService } from 'src/app/services/matricula-secretaria/matricula-secretaria.service';

@Component({
  selector: 'app-aluno',
  templateUrl: './aluno.component.html',
  styleUrls: ['./aluno.component.css'],
  providers: [CpfPipe],
})
export class AlunoComponent extends BaseComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  alunos: Aluno[];
  
  matriculasSecretariasFiltradas: Array<MatriculaSecretaria & { selecionado?: boolean }> = [];
  matriculasSecretariasNaoFiltradas: MatriculaSecretaria[] = [];

  mostrarTabela = false;
  msg: string;

  displayedColumns: string[] = ['matricula', 'nome', 'turmaSecretaria', 'turno', 'serie', 'dataEntrada', 'dataDesligamento', 'ativo', 'acoes'];
  dataSource: MatTableDataSource<Aluno> = new MatTableDataSource();

  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil;

  form: FormGroup;
  mascaraCpf = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/,];

  constructor(
    protected formBuilder: FormBuilder,
    private alunoService: AlunoService,
    private router: Router,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private cpfPipe: CpfPipe,
    private funcoesUteisService: FuncoesUteisService,
    private toastService: ToastService,
    private dataUtilService: DataUtilService,
    private matriculaSecretariaService: MatriculaSecretariaService,
  ) {
    super();
    this.carregarPerfil = new CarregarPerfil();
  }

  ngOnInit() {
    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);
    this.dataSource.paginator = this.paginator;
    this.matriculaSecretariaService.getAllBy(null, null).subscribe((matriculasSecretaria: MatriculaSecretaria[]) => {
      this.matriculasSecretariasNaoFiltradas = (matriculasSecretaria || []).slice();
      this.initializeMatriculasSecretariasFiltradas(this.matriculasSecretariasNaoFiltradas);
    });
    this.createForm();
    this.consultar();
  }

  private createForm(): void {
    this.form = this.formBuilder.group({
      beneficiario: [null],
      mae: [null],
      cpf: [null],
      dataInicioEntradaInstituicao: [null],
      dataFimEntradaInstituicao: [null],
      ativo: [true],
      turmaSecretaria: [null],
      matriculaSecretaria: [[]],
    });
  }

  private initializeMatriculasSecretariasFiltradas(matriculasSecretaria: MatriculaSecretaria[]) {
    this.matriculasSecretariasFiltradas = (matriculasSecretaria || []).map(m => ({ ...m, selecionado: true }));
    this.matriculasSecretariasFiltradas.sort((a, b) => {
      if (a.descricao > b.descricao) { return 1; }
      if (a.descricao < b.descricao) { return -1; }
      return 0;
    });
  }

  limpar() {
    this.mostrarTabela = false;
    this.dataSource.data = [];
    this.form.reset();
  }

  consultar() {
    const pageInfo = new PageInfo();
    if(this.paginator) {
      this.paginator.firstPage();
    }
    this.consultarAlunos(pageInfo);
  }

  private consultarAlunos(pageInfo: PageInfo) {
    const filtro = this.createFiltro();
    this.alunoService.listFilteredAndPaged(pageInfo, filtro)
      .subscribe((resp: any) => {
        this.numberItens = resp.totalElements;
        this.verificaMostrarTabela(resp.content);
      });
  }

  private createFiltro() {
    const filtro = new FiltroAluno();
    filtro.beneficiario = this.getValueForm(this.form, 'beneficiario');
    filtro.cpf = this.getValueForm(this.form, 'cpf');
    filtro.mae = this.getValueForm(this.form, 'mae');
    filtro.dataInicioEntradaInstituicao = this.getValueForm(this.form, 'dataInicioEntradaInstituicao');
    filtro.dataFimEntradaInstituicao = this.getValueForm(this.form, 'dataFimEntradaInstituicao');
    if(filtro.cpf) {
      filtro.cpf = filtro.cpf.replace(/[^0-9]/g,'');
    }
    filtro.ativo = this.getValueForm(this.form, 'ativo');
    const matriculasSecretarias = this.getValueForm(this.form, 'matriculaSecretaria') || [];
    filtro.matriculasSecretarias = matriculasSecretarias.length ? matriculasSecretarias : null;
    return filtro;
  }

  onEventPaginate(event?: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    const pageInfo = new PageInfo();
    pageInfo.pageSize = this.pageSize;
    pageInfo.actualPage = this.pageIndex;
    this.consultarAlunos(pageInfo);
  }


  atualizar(aluno: Aluno) {
    this.router.navigate(['/aluno/cadastrar'], { queryParams: { id: aluno.id } });
  }

  deletar(aluno: Aluno) {
    this.chamaCaixaDialogo(aluno);
  }

  chamaCaixaDialogo(aluno: Aluno) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      pergunta: `Certeza que deseja excluir o Aluno ?`,
      textoConfirma: 'SIM',
      textoCancela: 'NÃO'
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirma => {
      if (confirma) {
        this.alunoService.excluir(aluno.id).subscribe(() => {
          this.consultar();
        });
      } else {
        dialogRef.close();
      }
    });
  }


  verificaMostrarTabela(alunos: Aluno[]) {
    if (!alunos || alunos.length === 0) {
      this.mostrarTabela = false;
      this.msg = 'Nenhum aluno encontrado.';
    } else {
      this.mostrarTabela = true;
    }
    this.dataSource.data = alunos ? alunos : [];
  }


  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }

  limparPesquisaMatriculaSecretaria(): void {
    this.filtrarMatriculasSecretarias('');
  }

  selecionarTodasMatriculasSecretarias(): void {
    const ids = this.matriculasSecretariasFiltradas.map(matricula => matricula.id);
    this.form.get('matriculaSecretaria').setValue(ids);
    this.onMatriculasSecretariasChange(ids);
  }

  desmarcarTodasMatriculasSecretarias(): void {
    this.form.get('matriculaSecretaria').setValue([]);
  }

  onMatriculasSecretariasChange(idsSelecionados: number[]): void {
    if (!idsSelecionados || idsSelecionados.length === 0) { return; }
  }

  filtrarMatriculasSecretarias(termo: string): void {
    const termoNormalizado = (termo || '').trim().toLocaleLowerCase();
    this.matriculasSecretariasFiltradas = this.matriculasSecretariasNaoFiltradas
      .filter(matricula => !termoNormalizado ||
        (matricula.descricao || '').toLocaleLowerCase().includes(termoNormalizado))
      .map(matricula => ({ ...matricula }))
      .sort((a, b) => (a.descricao || '').localeCompare(b.descricao || ''));

    if (termoNormalizado) {
      const idsFiltrados = new Set(
        this.matriculasSecretariasFiltradas.map(matricula => matricula.id)
      );
      const controle = this.form.get('matriculaSecretaria');
      const idsSelecionados = controle.value || [];
      controle.setValue(idsSelecionados.filter(id => idsFiltrados.has(id)));
    }
  }
}
